import React, { useState, useEffect } from "react";
import { Grid, Header, Image, Placeholder } from "semantic-ui-react";

const SellContractHeader = ({ mydata, logosrc }) => {
  return (
    <Grid>
      <Grid.Row>
        <Grid.Column textAlign="right" width={5} verticalAlign="middle">
          <Image src={logosrc} size="small" />
        </Grid.Column>
        <Grid.Column textAlign="center" width={6} verticalAlign="middle">
          <p>بسمه تعالی</p>
          <Header size="medium">قرارداد فروش</Header>
        </Grid.Column>
        <Grid.Column width={5} verticalAlign="bottom">
          <div className="d-flex jc-end ai-end">
            تاریخ &nbsp;:&nbsp;
            <p>
              {mydata
                ? new Date(mydata.sale.insertdate).toLocaleDateString("fa")
                : null}
            </p>
          </div>

          {/* <Grid textAlign='center'>
                        <Grid.Row className='p-3-b'>
                            <Grid.Column width={8} textAlign='right'>شماره فاکتور : </Grid.Column>
                            <Grid.Column width={8} textAlign='left'>
                                <Header size='tiny' className='m-0'>{mydata.sale.publicNumber ? mydata.sale.publicNumber : mydata.sale.id}</Header>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row className='p-3-b'>
                            <Grid.Column width={8} textAlign='right'>ارجاع : </Grid.Column>
                            <Grid.Column width={8} textAlign='left'>
                                <Header size='tiny' className='m-0'>{mydata.sale.refrence}</Header>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row className='p-3-b'>
                            <Grid.Column width={8} textAlign='right'>تاریخ : </Grid.Column>
                            <Grid.Column width={8} textAlign='left'>
                                <Header size='tiny' className='m-0'>{mydata ? new Date(mydata.sale.insertdate).toLocaleDateString('fa') : null}</Header>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row className='p-3-b'>
                            <Grid.Column width={8} textAlign='right'>تاریخ سررسید : </Grid.Column>
                            <Grid.Column width={8} textAlign='left'>
                                <Header size='tiny' className='m-0'>{mydata ? new Date(mydata.sale.expiredate).toLocaleDateString('fa') : null}</Header>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid> */}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};
export default SellContractHeader;
